var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import Toggle from '@doordash/component-toggle';
import { InlineChildren, StackChildren, Icon, Text, } from '@doordash/design-language';
import Tooltip from '@doordash/component-tooltip';
import { InputContainer } from './budget_form_styles';
import { SearchableOptionsSelect, TagSize, } from '../../../searchable_option_select';
var formatGroupForSearchComponent = function (group) { return (__assign({ text: group.name, value: group.id }, group)); };
export var GroupsSelector = function (_a) {
    var _b = _a.groupsOptions, groupsOptions = _b === void 0 ? [] : _b, values = _a.values, setFieldValue = _a.setFieldValue;
    var _c = __read(React.useState(Boolean(values.budgetGroups && values.budgetGroups.length > 0)), 2), isGroupMode = _c[0], setIsGroupMode = _c[1];
    var _d = __read(React.useState(''), 2), searchText = _d[0], setSearchText = _d[1];
    var clearSearchText = function () { return setSearchText(''); };
    var _e = __read(React.useState(''), 2), noOptionText = _e[0], setNoOptionText = _e[1];
    var _f = __read(React.useState((values.budgetGroups &&
        values.budgetGroups.map(formatGroupForSearchComponent)) ||
        []), 2), selectedOptions = _f[0], setSelectedOptions = _f[1];
    var areGroupsAvailable = groupsOptions.length > 0;
    var getGroupsOptions = function (options, query) {
        if (options === void 0) { options = []; }
        if (query === void 0) { query = ''; }
        return options
            .filter(function (option) {
            return option.name.toLowerCase().includes(query.toLocaleLowerCase());
        })
            .map(formatGroupForSearchComponent);
    };
    var _g = __read(React.useState(getGroupsOptions(groupsOptions)), 2), options = _g[0], setOptions = _g[1];
    var setToAllMembers = function () {
        setIsGroupMode(false);
        setFieldValue('budgetGroups', []);
    };
    var setToSpecificGroups = function () {
        setIsGroupMode(true);
        setFieldValue('budgetGroups', selectedOptions);
    };
    React.useEffect(function () {
        if (!searchText || searchText.length < 2) {
            // minimum 2 chars to start filtering group names
            setOptions(getGroupsOptions([]));
            setNoOptionText('');
            return;
        }
        var filteredOptions = getGroupsOptions(groupsOptions, searchText);
        if (filteredOptions.length === 0) {
            setNoOptionText('No groups matching your search');
        }
        setOptions(filteredOptions);
    }, [searchText]);
    var onAddOption = React.useCallback(function (option) {
        setSelectedOptions(__spread(selectedOptions, [option]));
        setFieldValue('budgetGroups', __spread(selectedOptions, [option]));
    }, [setSelectedOptions, selectedOptions]);
    var onRemoveOption = React.useCallback(function (option) {
        var newSelectedOptions = __spread(selectedOptions).filter(function (opt) {
            return opt.value !== option.value;
        });
        setSelectedOptions(newSelectedOptions);
        setFieldValue('budgetGroups', newSelectedOptions);
    }, [setSelectedOptions, selectedOptions]);
    return (React.createElement(InputContainer, { size: "large" },
        React.createElement(StackChildren, { size: StackChildren.Sizes.XxSmall },
            React.createElement(Text, { styles: Text.Styles.Label2Emphasis }, "Apply budget to"),
            React.createElement(InlineChildren, { size: InlineChildren.Sizes.XSmall, alignItems: InlineChildren.Alignment.FlexStart },
                React.createElement(Toggle, { label: "All members", name: "groupType", type: Toggle.Types.Radio, size: Toggle.Sizes.Large, isSelected: !isGroupMode, onChange: function () { return setToAllMembers(); } }),
                React.createElement(InlineChildren, { size: InlineChildren.Sizes.XxSmall, alignItems: InlineChildren.Alignment.FlexStart },
                    React.createElement(Toggle, { label: "Specific groups", name: "groupType", type: Toggle.Types.Radio, size: Toggle.Sizes.Large, isSelected: isGroupMode, isDisabled: !areGroupsAvailable, onChange: function () { return setToSpecificGroups(); } }),
                    !areGroupsAvailable && (React.createElement(Tooltip, { content: "No active groups are available. Please create groups using the 'Groups' tab.", position: Tooltip.Positions.TopCenter, size: Tooltip.Sizes.Small }, function () { return (React.createElement(Icon, { size: Icon.Sizes.Medium, type: Icon.Types.InfoCircleLine })); })))),
            isGroupMode && (React.createElement(SearchableOptionsSelect, { name: "groups-selector", width: '360px', placeholder: "Search by group name", noOptionText: noOptionText, clearSearchText: clearSearchText, setSearchText: setSearchText, options: options, selectedOptions: selectedOptions, searchText: searchText, onAddOption: onAddOption, onRemoveOption: onRemoveOption, label: "", isLoading: false, allowMultiSelect: false, tagSize: TagSize.Medium })))));
};
export default GroupsSelector;
